import React from "react";
import ReactDOM from "react-dom/client";
import "./api/httpBootstrap"; // must run before any api/*.ts module issues a fetch
import { App } from "./App";
import { AuthGate } from "./auth/AuthGate";
import "./styles/styles.css";

const root = document.getElementById("root");
if (!root) throw new Error("#root not found in index.html");
ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <AuthGate>
      <App />
    </AuthGate>
  </React.StrictMode>,
);
